"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingEffectsImportHelper = void 0;
var dx_color_1 = require("../../../../../core/model/color/dx-color");
var DrawingEffectsImportHelper = (function () {
    function DrawingEffectsImportHelper() {
    }
    DrawingEffectsImportHelper.getColorProperty = function (colorValue) {
        return dx_color_1.DXColor.fromRgb(colorValue & 0x000000FF, (colorValue & 0x0000FF00) >> 8, (colorValue & 0x00FF0000) >> 16);
    };
    return DrawingEffectsImportHelper;
}());
exports.DrawingEffectsImportHelper = DrawingEffectsImportHelper;
